/**
 * Platform Detection
 * 
 * Определяет на какой платформе запущено приложение
 */

export type Platform = 'telegram' | 'vk' | 'web' | 'embed';

/**
 * Определить текущую платформу
 */
export function detectPlatform(): Platform {
  // VK Mini App - проверяем URL параметры от VK
  if (typeof window !== 'undefined') {
    const search = window.location.search;
    const pathname = window.location.pathname;
    
    // VK передаёт параметры vk_user_id, vk_app_id и т.д.
    if (search.includes('vk_user_id') || 
        search.includes('vk_app_id') ||
        pathname.startsWith('/vk')) {
      const p = new URLSearchParams(search);
      if (p.get('vk_user_id')) sessionStorage.setItem('vk_user_id', p.get('vk_user_id')!);
      return 'vk';
    }
    if (sessionStorage.getItem('vk_user_id')) {
      return 'vk';
    }
    
    // Telegram Mini App
    if ((window as any).Telegram?.WebApp?.initData) {
      return 'telegram';
    }
    
    // Embed режим
    if (pathname.startsWith('/embed')) {
      return 'embed';
    }
  }
  
  // По умолчанию - web
  return 'web';
}

/**
 * Проверка конкретной платформы
 */
export const isTelegram = () => detectPlatform() === 'telegram';
export const isVK = () => detectPlatform() === 'vk';
export const isWeb = () => detectPlatform() === 'web';
export const isEmbed = () => detectPlatform() === 'embed';

/**
 * Витрина курсов (kurs.mugstel.ru): та же платформа, но без игровой части.
 * Разделены только входы — движок, прогресс и данные общие.
 */
export function isCoursesSite(): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.startsWith('kurs.');
}
